import { render, staticRenderFns } from "./BuyerAnalyticsViewSwitch.vue?vue&type=template&id=a05d29ea&"
import script from "./BuyerAnalyticsViewSwitch.vue?vue&type=script&lang=ts&"
export * from "./BuyerAnalyticsViewSwitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VFlex,VLayout,VSwitch})
